export const ArrowDownV2 = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 12.9791L12 17.9791M12 17.9791L17 12.9791M12 17.9791V4.97906"
      stroke="#253E2C"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
